<template>
  <ButtonComponent
      id="request_google_login"
      :variant="$props.variant"
      :text="buttonText[$props.type][$props.lang] || buttonText[$props.type]['EN']"
      :image="'https://cdn.systemico.net/abc/icons/google.svg'"
      @click="loginWithGoogle()"
      class="text-center">
  </ButtonComponent>
  <!--../../../../assets/images/logo__google.svg-->
</template>
<script>
import ButtonComponent from './ButtonComponent.vue'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
export default {
  name: 'ButtonGoogleLogin',
  components: {
    ButtonComponent
  },
  props: {
    variant: {
      type: String,
      variant: 'secondary'
    },
    lang: {
      type: String,
      default: 'EN'
    },
    type: {
      type: String,
      default: 'LOGIN'
    },
    urlcallback: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buttonText: {
        LOGIN: {
          EN: 'Sign in <b>with Google</b>',
          ES: 'Iniciar <b>con Google</b>',
          PT: 'Entrar <b>com o Google</b>',
          FR: 'Se connecter <b>avec Google</b>'
        },
        SIGNUP: {
          EN: 'Sign up <b>with Google</b>',
          ES: 'Regístrate <b>con Google</b>',
          PT: 'Cadastrar-se <b>com o Google</b>',
          FR: 'S\'inscrire <b>avec Google</b>'
        }
      }
    }
  },
  beforeMount () {
    if (this.lang !== 'EN' && this.lang !== 'ES' && this.lang !== 'PT' && this.lang !== 'FR') {
      this.lang = 'EN'
    }
  },
  methods: {
    /* loginWithGoogle () {
      // REDIRECT SITE
      window.location.href = '/api/glogin/validate';
    }, */
    async loginWithGoogle () {
      const backendUrl = process.env.VUE_APP_BACKEND_URL || '/api'
      const url = `${backendUrl}/glogin/validate${this.$props.urlcallback}`

      if (Capacitor.getPlatform() === 'web') {
        window.location.href = url
      } else {
        await Browser.open({ url })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @use "../../assets/styles/variables.scss" as *;
</style>
